type TestIdPrefix =
  | 'Accordion'
  | 'Banner'
  | 'Block'
  | 'Button'
  | 'Card'
  | 'Checkbox'
  | 'Dropdown'
  | 'Footer'
  | 'Form'
  | 'Header'
  | 'Icon'
  | 'Image'
  | 'Input'
  | 'Label'
  | 'Link'
  | 'List'
  | 'Loader'
  | 'Menu'
  | 'Modal'
  | 'Notification'
  | 'Page'
  | 'Popover'
  | 'Progress'
  | 'Radio'
  | 'Select'
  | 'Sidebar'
  | 'Spinner'
  | 'Table'
  | 'Tabs'
  | 'Tag'
  | 'Text'
  | 'Toast'
  | 'Tooltip';

type TestIdElement<Prefix extends string> = `${Prefix}${string}`;
type TestIdConfig<V extends string> = {
  [K in TestIdElement<V>]: K;
};

/**
 * Test ids for the application
 * Naming convention:
 * - Use `Page` prefix for page level test ids
 * - Use element type as prefix for element level test ids
 */
export const TestId = {
  BannerConnectOverdue: 'BannerConnectOverdue',
  BannerEnterpriseEnrollmentContinue: 'BannerEnterpriseEnrollmentContinue',
  CheckboxEnterpriseVerifySAML: 'CheckboxEnterpriseVerifySAML',
  ModalEnterpriseStartMigration: 'ModalEnterpriseStartMigration',
  ModalEnterpriseStartDomainForwarding: 'ModalEnterpriseStartDomainForwarding',
  NotificationEnterpriseStartMigration: 'NotificationEnterpriseStartMigration',
  NotificationEnterpriseStartDomainForwarding:
    'NotificationEnterpriseStartDomainForwarding',
  NotificationEnterpriseDeviceComplianceStatus:
    'NotificationEnterpriseDeviceComplianceStatus',
  PageAccessDenied: 'PageAccessDenied',
  PageEnterpriseEnrollmentAccountLinkingMismatchError:
    'PageEnterpriseEnrollmentAccountLinkingMismatchError',
  PageEnterpriseEnrollmentConfirmSetup: 'PageEnterpriseEnrollmentConfirmSetup',
  PageEnterpriseEnrollmentCreateOrganization:
    'PageEnterpriseEnrollmentCreateOrganization',
  PageEnterpriseEnrollmentSetup: 'PageEnterpriseEnrollmentSetup',
  PageEnterpriseEnrollmentSetupSAML: 'PageEnterpriseEnrollmentSetupSAML',
  PageEnterpriseEnrollmentVerifyDomain: 'PageEnterpriseEnrollmentVerifyDomain',
  PageEnterpriseEnrollmentVerifySAML: 'PageEnterpriseEnrollmentVerifySAML',
  PageEnterpriseMembers: 'PageEnterpriseMembers',
  PageEnterprisePlan: 'PageEnterprisePlan',
  PageEnterpriseOffboarding: 'PageEnterpriseOffboarding',
  PageEnterprisePolicies: 'PageEnterprisePolicies',
  PageHome: 'PageHome',
  PageVerifyEmail: 'PageVerifyEmail',
  PageEnterpriseDomains: 'PageEnterpriseDomains',
  NotificationManagedDevicesNoUnpair: 'NotificationManagedDevicesNoUnpair',
  FormPolicyProfile: 'FormPolicyProfile',
  ButtonSubmitPolicyProfile: 'ButtonSubmitPolicyProfile',
  FormInviteToEnterpriseByEmail: 'FormInviteToEnterpriseByEmail',
  FormCreateOrganization: 'FormCreateOrganization',
  PageDataAccessConsent: 'PageDataAccessConsent',
  TagConsentStatus: 'TagConsentStatus',
  TextConsentDescription: 'TextConsentDescription',
  ButtonGrantMetadataAccess: 'ButtonGrantMetadataAccess',
  ButtonGrantFullAccess: 'ButtonGrantFullAccess',
  ButtonRevokeAccess: 'ButtonRevokeAccess',
  NotificationConsentStatusError: 'NotificationConsentStatusError',
} as const satisfies TestIdConfig<TestIdPrefix>;

export type TestId = (typeof TestId)[keyof typeof TestId];
